import { z } from 'zod'
import { LastNameSchema } from '../../domains/last-name'
import { NameSchema } from '../../domains/name'
import { optionalString, requiredString } from '../../primitives'
import { MESSAGES } from '../../utils/messages'

/**
 * Estructura accionaria / de participación del cliente jurídico (sólo entidades
 * lucrativas con accionistas al 10%+). Espejo enfocado del FEIC interno
 * (features/juridical/models/juridical-schema.ts): accionistas persona individual y
 * persona jurídica, cada uno con su porcentaje de participación y si es extranjero.
 */

const participation = z
  .number({ invalid_type_error: MESSAGES.REQUIRED })
  .min(0.01, MESSAGES.REQUIRED)
  .max(100, 'No puede superar el 100%')

/** Accionista/socio persona INDIVIDUAL. */
export const ShareholderIndividualSchema = z.object({
  id: optionalString(),
  name: NameSchema,
  lastName: LastNameSchema,
  participation,
  foreign: z.boolean()
})

/** Accionista/socio persona JURÍDICA (razón/denominación social). */
export const ShareholderJuridicalSchema = z.object({
  id: optionalString(),
  name: requiredString(),
  participation,
  foreign: z.boolean()
})

/** Estructura accionaria: dos arreglos (individuales + jurídicos). */
export const ShareholdingStructureSchema = z.object({
  individual: z.array(ShareholderIndividualSchema).default([]),
  juridical: z.array(ShareholderJuridicalSchema).default([])
})

export type ShareholderIndividual = z.infer<typeof ShareholderIndividualSchema>
export type ShareholderJuridical = z.infer<typeof ShareholderJuridicalSchema>
export type ShareholdingStructure = z.infer<typeof ShareholdingStructureSchema>
